/** Admin stock MFE + host stock pages feature reducers */
export async function loadStockReducers() {
  const [
    stockItems,
    stockLayout,
    stockCategory,
    stockGroup,
    uom,
    uomConversions,
    stockSupplier,
    puom,
    stockLocation,
    reorderPoint,
    stockRecipes,
    stockWastage,
    stockBrand,
    virtualLocation,
    stockPosRouting,
    stockTableFloorRouting,
    stockLists,
  ] = await Promise.all([
    import('../reducers/StockItemsReducer'),
    import('../reducers/StockLayoutReducer'),
    import('../reducers/StockCategoryReducer'),
    import('../reducers/StockGroupReducer'),
    import('../reducers/UomReducer'),
    import('../reducers/UomConversionsReducer'),
    import('../reducers/StockSupplierReducer'),
    import('../reducers/PuomReducer'),
    import('../reducers/StockLocationReducer'),
    import('../reducers/ReorderPointsReducer'),
    import('../reducers/RecipeReducer'),
    import('../reducers/stockWastageReducer'),
    import('../reducers/stockBrandReducer'),
    import('../reducers/VirtualLocationsReducer'),
    import('../reducers/StockPosRoutingReducer'),
    import('../reducers/StockTableAndFloorRoutingReducer'),
    import('../reducers/stockListsReducer'),
  ]);

  return {
    stockItems: stockItems.default,
    stockLayout: stockLayout.default,
    stockCategory: stockCategory.default,
    stockGroup: stockGroup.default,
    uom: uom.default,
    uomConversions: uomConversions.default,
    stockSupplier: stockSupplier.default,
    puom: puom.default,
    stockLocation: stockLocation.default,
    reorderPoint: reorderPoint.default,
    stockRecipes: stockRecipes.default,
    stockWastage: stockWastage.default,
    stockBrand: stockBrand.default,
    virtualLocation: virtualLocation.default,
    stockPosRouting: stockPosRouting.default,
    stockTableFloorRouting: stockTableFloorRouting.default,
    stockLists: stockLists.default,
  };
}
